import React, { useCallback } from 'react'
import { Box, Circle } from '@chakra-ui/react'
import PropTypes from 'prop-types'
import rootStore from '../../../store/RootStore'
import { observer } from 'mobx-react'

const MOUSE_GAP = -20
const ChartAnnotationLayer = observer(({ onClick, bounds, id, ...rest }) => {
  const {
    commentStore: {
      isFormVisible,
      commentsDrawerVisible,
      rootComments,
      loadingChartComments,
      tempComment,
      setTempComment,
      chartId,
    },
  } = rootStore
  const handleAddComments = useCallback(
    e => {
      if (!isFormVisible) {
        setTempComment({})
        return
      }

      const { x, y } = e.currentTarget.getBoundingClientRect()
      const posX = e.clientX - x + MOUSE_GAP
      const posY = e.clientY - y + MOUSE_GAP

      setTempComment({
        coords: {
          x: posX,
          y: posY,
        },
        ...tempComment,
      })
    },
    [isFormVisible, setTempComment, tempComment],
  )

  if (
    loadingChartComments ||
    (commentsDrawerVisible && chartId !== id) ||
    !commentsDrawerVisible
  ) {
    return null
  }

  return (
    <Box
      position="absolute"
      width={commentsDrawerVisible ? `${bounds?.width}px` : 0}
      height={`${bounds?.height}px`}
      left={0}
      top={0}
      zIndex={1}
      cursor={isFormVisible ? 'crosshair' : 'auto'}
      onClick={handleAddComments}
      {...rest}>
      {tempComment.coords && (
        <AnnotationComment
          key="new-comment"
          id={'-1'}
          value={rootComments?.length || 0}
          coords={tempComment.coords}
          onClick={onClick}
        />
      )}
      {rootComments?.map((annotation, index) => {
        return (
          <AnnotationComment
            key={index}
            id={index}
            value={index}
            coords={annotation.coords}
            onClick={onClick}
          />
        )
      })}
    </Box>
  )
})

export const AnnotationComment = ({ id, value, coords, onClick }) => {
  if (!coords) return

  return (
    <Box
      position="absolute"
      left={coords.x + 'px'}
      top={coords.y + 'px'}
      onClick={onClick}
      cursor="pointer"
      data-id={id}>
      <Circle
        w="32px"
        h="32px"
        border="2px solid"
        borderColor="white"
        backgroundColor="brand.lightOrange"
        alignItems="center"
        color="white"
        justifyContent="center"
        fontWeight="bold"
        boxShadow="0 0 8px rgba(0, 0, 0, .1)">
        {value + 1}
      </Circle>
    </Box>
  )
}

ChartAnnotationLayer.propTypes = {
  onClick: PropTypes.func,
}
AnnotationComment.propTypes = {
  value: PropTypes.number || PropTypes.string,
  coords: PropTypes.shape({
    x: PropTypes.number || PropTypes.string,
    y: PropTypes.number || PropTypes.string,
  }),
  onClick: PropTypes.func,
}
export default ChartAnnotationLayer
